import React, { Component } from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import styles from '../../../constants/styles'

const text = [
  'We will be processing your application. Allow us 2-5 working days to review your request. We’ll reach out to you via your social media accounts.',
  "You will receive an email in the next 2-3 weeks with all the necessary details. Check your spam folder in case you didn't receive it.",
  "We encourage you to write your first 10 reviews if you haven't done so already. It'll help you better understand our platform and you'll also be able to donate to one of our non-profit partners!"
]

class Success extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.containerRef = null
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <Main>
        <Title>Thank you!</Title>
        <SubTitle>Your application has been submitted</SubTitle>

        <IconDiv>
          <CheckCircleIcon sx={{ color: 'green', fontSize: 115 }} />
        </IconDiv>

        <Card>
          <Question>What happens next?</Question>
          <List>
            {text.map((t) => (
              <ListItem key={t}>{t}</ListItem>
            ))}
          </List>
        </Card>
        <Text>
          Do you have any queries?&nbsp;{' '}
          <ContactLink href="/faq">
            <a>Visit our FAQ!</a>
          </ContactLink>
        </Text>
      </Main>
    )
  }
}

export default Success

const Main = styled.main`
  width: 100%;
  min-height: calc(100vh - 96px);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${styles.margin.large};
  padding: 0 ${styles.padding.medium};
`
const Title = styled.h1``
const SubTitle = styled.h2`
  color: ${styles.colors.grey};
  margin: ${styles.margin.medium};
  text-align: center;
  font-size: 1.5em;
`

const IconDiv = styled.div`
  display: flex;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${styles.colors.lightGrey};
  border-radius: 24px;
  width: 100%;
  max-width: 600px;
  padding: ${styles.padding.medium};
`
const List = styled.ul`
  padding-left: ${styles.padding.small};
`
const Text = styled.li`
  color: ${styles.colors.black};
  font-size: 1em;
  text-align: left;
  margin: ${styles.margin.small};
`
const ListItem = styled(Text)`
  list-style: square;
  list-style-type: disc;
  margin-bottom: ${styles.margin.medium};
`
const Question = styled(Text)`
  text-align: center;
  font-weight: 600;
`
const ContactLink = styled(Link)`
  color: ${styles.colors.orange};
  font-size: 0.9em;
`
